import * as actions from "./actions";

const initialState = {
    // The settings of the search shown, keyed by definitionId.
    settingsByDefinition: {},
    // The searches whose setting is being changed, by definitionId.
    settingBirth: {},
    // The outcome of the last change ({ success, definitionId, ... }), until it has been shown.
    setBirthResult: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.GET_DUPLICATE_SEARCH_SETTINGS_SUCCESS:
        case actions.SET_DUPLICATE_SEARCH_BIRTH_SUCCESS: {
            const settings = action.payload;
            const next = { ...state, settingsByDefinition: { ...state.settingsByDefinition, [settings.definitionId]: settings } };
            return action.type === actions.SET_DUPLICATE_SEARCH_BIRTH_SUCCESS
                ? { ...next, settingBirth: { ...state.settingBirth, [settings.definitionId]: false }, setBirthResult: { success: true, definitionId: settings.definitionId, birthEnabled: settings.birthEnabled } }
                : next;
        }
        case actions.GET_DUPLICATE_SEARCH_SETTINGS_FAILURE: {
            const { [action.payload.definitionId]: _dropped, ...rest } = state.settingsByDefinition;
            return { ...state, settingsByDefinition: rest };
        }
        case actions.SET_DUPLICATE_SEARCH_BIRTH_REQUEST:
            return { ...state, settingBirth: { ...state.settingBirth, [action.params.definitionId]: true }, setBirthResult: null };
        case actions.SET_DUPLICATE_SEARCH_BIRTH_FAILURE:
            return { ...state, settingBirth: { ...state.settingBirth, [action.payload.definitionId]: false }, setBirthResult: { success: false, ...action.payload } };
        case actions.CLEAR_DUPLICATE_SEARCH_BIRTH_RESULT:
            return { ...state, setBirthResult: null };
        default:
            return state;
    }
};
